export const FILE_ICONS = {
  'application/zip': 'file-archive',
  'application/pdf': 'file-pdf',
  'application/msword': 'file-word',
  'application/vnd.ms-excel': 'file-excel',
  'application/vnd.ms-powerpoint': 'file-powerpoint',
  'image/jpeg': 'file-image',
  'image/png': 'file-image',
  'image/gif': 'file-image',
  'video/mpeg': 'file-video',
  'audio/x-wav': 'file-music',
  'audio/webm': 'file-music',
  default: 'file',
};

export const getFileIcon = type => {
  if (FILE_ICONS[type]) {
    return FILE_ICONS[type];
  }
  return FILE_ICONS.default;
};
